module.exports = __webpack_public_path__ + "static/media/close.0985241f.svg";